import React from 'react';
import PropTypes from 'prop-types';

import colors from 'theme/_colors.scss';
import { IconClose } from 'svgIcons/MotionPortalIcons';
import { getNotificationIcons } from './helper';

const NotificationBanner = ({ message, onClose, isHide = true, type = 'info' }) => {
    return <div className={`notification-banner w-100 mt-2 ${isHide ? '' : 'd-none'}`}>
        <div className='d-flex align-items-center'>
            <div className='notification-icon-container'>
                {getNotificationIcons(type)}
            </div>
            <div className='notification-banner-text ms-2'>{message}</div>
        </div>
        <div
            id='closeNotifyButton'
            role='presentation'
            onClick={onClose}
        >
            <IconClose
                color={colors.nero}
                strokeWidth='6' />
        </div>
    </div>;
};

NotificationBanner.propTypes = {
    message: PropTypes.oneOfType([
        PropTypes.string, // Message as a string
        PropTypes.element, // Message as a React element
    ]), // The message to display (required)
    onClose: PropTypes.func, // Function to handle the close action (required)
    isHide: PropTypes.bool, // Whether the banner is hidden
    type: PropTypes.oneOf(['info', 'warning', 'error', 'success']), // Type of notification (restricted to specific values)
};

export default React.memo(NotificationBanner);
